import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './utils/msalConfig';
import Navbar from './components/common/Navbar';
import Admin from './pages/Admin';
import Meetings from './pages/Meetings';
import Login from './pages/Login';
import ProtectedRoute from './components/common/ProtectedRoute';
import './App.css'

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route 
                path="/admin/*" 
                element={
                    <ProtectedRoute requireAdmin={true}>
                    <Admin />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/meetings" 
                element={
                  <ProtectedRoute>
                    <Meetings />
                  </ProtectedRoute>
                } 
              />
              <Route path="/" element={<Login />} />
            </Routes>
            </main>
        </div>
      </Router>
    </MsalProvider>
  );
};

export default App;